import React from "react";
import { mapLink, WazeLink } from "../../assets/images/logourl";
import "./Footer.css";
function Footer() {
  const mapUrl =
    "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Google_Maps_icon_%282015-2020%29.svg/2048px-Google_Maps_icon_%282015-2020%29.svg.png";
  const mailUrl = `https://thumbs.dreamstime.com/b/gmail-logo-google-llc-apps-official-new-logotypes-vector-icon-email-service-developed-redesigned-version-eps-file-201198491.jpg`;
  return (
    <div className="footer-con">
      <div className="footer">
        <div className="location-links">
          {" "}
          <a href={mapLink}>
            <img style={{ width: 45 }} src={mapUrl} alt="location" />
          </a>
          <a href={WazeLink}>
            <i
              style={{
                fontSize: 45,
                color: "black",
                // backgroundColor: "lightblue",
              }}
              className="fa-brands fa-waze"
            ></i>
          </a>
        </div>
        <div className="website-support">
          <h4>תמיכה באתר: אפרים לוי</h4>
          <a href="https://wa.me/+972504624618">
            <img
              
              src={require(`../../assets/images/WhatsAppButtonGreenSmall.png`)}
              alt=""
            />
          </a>
        </div>
        <div className="store-contact">
          <div>
            <h4>צור קשר</h4>
            <h5>
              {/* <i className="fa-solid fa-phone"></i>  */}
              טלפון:  
              <a style={{color:"black"}} href="tel:+97229938075"> 029938075</a> 
            </h5>
            <h5>פקס:
            <a style={{color:"black"}} href="tel:+97229932778"> 029932778</a> 
            </h5>
          </div>
          <div>
            <a href="mailto:55morbo@gmail.com">
              <img style={{ width: 75 }} src={mailUrl} alt="mail" />
            </a>
          </div>
          {/* <div className="contact-form">
            <label htmlFor="name">name:</label>
            <input type="text" placeholder="name" />
            <input type="text" placeholder="name" />
            <textarea
              resize="none"
              id="massage-to-client"
              name="massage"
              rows="3"
              cols="10"
            ></textarea>
          </div> */}
        </div>
        <div className="services">
          <div style={{display:"flex"}}><h4>כל בו אפרת </h4></div>
          <div >
            <h5> צילום בצבע</h5>
            <h5>שכפול מפתחות</h5>
            <h5>ייעוץ מקצועי</h5>
          </div>
        </div>
      </div>
      <div>כל הזכויות שמורות לאפרים לוי © 2022 </div>
    </div>
  );
}

export default Footer;
